import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import {
  normalizeProposalIdParam,
  resetProposalViewInfoQueries
} from "./invalidateProposalViewInfoQueries";

/**
 * Resets proposal-detail queries whenever this route becomes active again
 * (location key changes after returning from complementary flow / nested routes).
 * Skips the first run after mount — initial fetch is handled by useQuery.
 */
export function useRefetchProposalViewInfoQueries(
  proposalId: string | number | string[] | undefined
): void {
  const queryClient = useQueryClient();
  const { key } = useLocation();
  const isFirstCycle = useRef(true);
  const normalizedId = normalizeProposalIdParam(proposalId);

  useEffect(() => {
    if (!normalizedId) {
      return;
    }

    if (isFirstCycle.current) {
      isFirstCycle.current = false;
      return;
    }

    void resetProposalViewInfoQueries(queryClient, normalizedId);
  }, [key, normalizedId, queryClient]);
}
